import { ICopyable, IJsonSerializable, IOpChangeState } from '../util/interfaces'
import { Enums } from '../common/enums'
import { OpNotificationDeliveryType } from '../core/op-notification-delivery-type'

export class OpConsumerNotificationContent implements IOpChangeState, IJsonSerializable, ICopyable<OpConsumerNotificationContent> {

    // #region Properties

    public idNotificationDeliveryType: number
    public destinationAddress: string
    public isActive: boolean

    // #endregion


    // #region Navigation Properties

    public notificationDeliveryType: OpNotificationDeliveryType

    // #endregion


    // #region Ctor

    constructor(opObj: any = null) {
        if (opObj instanceof OpConsumerNotificationContent) {
            this.copy(<OpConsumerNotificationContent>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    // #endregion


    // #region IOpChangeState implementation

    public opState: Enums.OpChangeState

    // #endregion


    // #region IJsonSerializable
    
    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idNotificationDeliveryType = opObj.IdNotificationDeliveryType
            this.destinationAddress = opObj.DestinationAddress
            this.isActive = opObj.IsActive
            this.opState = opObj.OpState

            this.notificationDeliveryType = opObj._notificationDeliveryType != null ? new OpNotificationDeliveryType(opObj._notificationDeliveryType) : null
        } else {
            this.opState = Enums.OpChangeState.New
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            IdNotificationDeliveryType: this.idNotificationDeliveryType,
            DestinationAddress: this.destinationAddress,
            IsActive: this.isActive,
            OpState: this.opState,
            _notificationDeliveryType: this.notificationDeliveryType != null ? this.notificationDeliveryType.toJSON() : null
        }
    }

    // #endregion


    // #region ICopyable

    public clone(includeNavigationProperties: boolean, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): any {
        const consumerNotificationContent: OpConsumerNotificationContent = new OpConsumerNotificationContent()

        consumerNotificationContent.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return consumerNotificationContent
    }

    public copy(source: OpConsumerNotificationContent, includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): void {

        if (source == null) {
            return null
        }

        if (includeNavigationProperties) {
            this.notificationDeliveryType = source.notificationDeliveryType != null ? source.notificationDeliveryType.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues) : null
        }

        if (includeCustomProperties) {
            // No Custom Properties
        }

        if (includeDataList) {
            // No Data List
        }

        if (includeDynamicValues) {
            // No Dynamic Values
        }

        this.idNotificationDeliveryType = source.idNotificationDeliveryType
        this.destinationAddress = source.destinationAddress
        this.isActive = source.isActive

        this.opState = source.opState
    }

    // #endregion
}


